export enum InfoStatusEnum {
    APPROVED = 'APPROVED',
    NOT_APPROVED = 'NOT_APPROVED',
    REVIEW_PENDING = 'REVIEW_PENDING'
}



// WEBPACK FOOTER //
// ./src/types/enums/InfoStatusEnum.ts